<template>
    <div class="policy" :class="[
        !policyLoading ? `policy--${policyStatusColor}` : null,
        { 'policy--expanded': showMoreDetails },
    ]">
        <Loading v-if="policyLoading" />
        <template v-else>
            <div class="row row--policy box box--default" :class="{ 'row--active': showMoreDetails }">

                <div class="row__data row__data--medium row__data--fixed"
                    :class="{ 'row__data--underline': $checkRolePermission('policy_edit') }">
                    <span v-if="$checkRolePermission('policy_edit')" @click="handleStatusPopup(policy.team_id)">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showStatusPopup" @togglePopup="showStatusPopup = $event"
                                :items="policyStatuses" :selected="policyStatus" :label="'name'"
                                @submit="updatePolicyStatus($event)" ref="inputElement" />
                        </transition>
                        {{ policyStatus }}
                    </span>
                    <span v-else>
                        {{ policyStatus }}
                    </span>
                </div>

                <div class="row__data row__data--medium"
                    :class="{ 'row__data--underline': $checkRolePermission('policy_edit') }">
                    <span v-if="$checkRolePermission('policy_edit')" @click="showPolicyNumberPopup = true">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showPolicyNumberPopup" @togglePopup="showPolicyNumberPopup = $event"
                                :selected="policyNumber" @submit="updatePolicyNumber($event)" />
                        </transition>
                        {{ policyNumber }}
                    </span>
                    <span v-else>
                        {{ policyNumber }}
                    </span>
                </div>

                <div v-if="plateNumber" class="row__data row__data--medium"
                    :class="{ 'row__data--underline': $checkRolePermission('policy_edit') }">
                    <span @click="$checkRolePermission('policy_edit') ? (showPolicyPlateNrPopup = true) : null"
                        :style="{ cursor: $checkRolePermission('policy_edit') ? 'pointer' : 'default' }">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showPolicyPlateNrPopup && $checkRolePermission('policy_edit')"
                                @togglePopup="showPolicyPlateNrPopup = $event" :selected="plateNumber"
                                @submit="updatePlateNumber($event)" />
                        </transition>

                        {{ plateNumber }}
                    </span>
                </div>

                <div class="row__data row__data--medium" v-else> ------</div>

                <div class="row__data row__data--medium">{{ createdAt }}</div>

                <div class="row__data row__data--medium" :class="{
                    'row__data--underline': $checkRolePermission('policy_edit')
                }">
                    <span @click="$checkRolePermission('policy_edit') ? (showSubmitDatePopup = true) : null"
                        :style="{ cursor: $checkRolePermission('policy_edit') ? 'pointer' : 'default' }">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showSubmitDatePopup && $checkRolePermission('policy_edit')"
                                :isDate="true" @togglePopup="showSubmitDatePopup = $event" :selected="submitDate"
                                @submit="updateSubmitDate($event)" />
                        </transition>

                        {{ submitDate }}
                    </span>
                </div>

                <div class="row__data row__data--medium policy__company">
                    <span>{{ company }}</span>
                </div>
                <div class="row__data row__data--medium">
                    {{ branch }}
                </div>
                <div class="row__data row__data--medium row__data--underline agent-field"
                    v-if="$checkRolePermission('policy_edit')">

                    <span @click="getPolicyFormData(policy.team_id); showAgentPopup = true">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showAgentPopup" @togglePopup="showAgentPopup = $event" :items="agents"
                                :selected="agent" :position="'left'" :label="['first_name', 'last_name']"
                                @submit="updatePolicyAgent($event)" />
                        </transition>
                        {{ agent }}
                    </span>

                    <span v-if="policy.second_agent != null">
                        {{ agent2 }}
                    </span>

                </div>

                <div class="row__data row__data--medium agent-field" v-else>
                    <span>
                        {{ agent }}
                    </span>
                    <span v-if="policy.second_agent != null">
                        {{ agent2 }}
                    </span>
                </div>

                <div class="row__data row__data--medium row__data--half row__data--last">
                    <div class="row__data row__data--small row__data--pdf icon icon__pdf"
                        :class="{ 'icon__pdf--active': policy.policy_files.length }" @click="openPolicyFilesModal()">
                    </div>
                    <div class="row__data row__data--small row__data--more"
                        :class="{ 'row__data--rotate': showMoreDetails }" @click="showMoreDetails = !showMoreDetails">
                    </div>
                </div>
            </div>
            <div class="policy__services" :class="{ 'policy__services--expand': showMoreDetails }">
                <div class="services" ref="servicesRef" :style="showMoreDetails
                    ? { maxHeight: `${servicesHeight}px` }
                    : { maxHeight: 0 }
                    " :class="{ 'services--expand': showMoreDetails }">
                    <div class="services__no-data" v-if="!services.length">
                       {{ $t(`policies.${"tableHead"}.${"noServicesMsg"}`) }}
                    </div>
                    <template v-else>
                        <div class="table__header table__header--inner">
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"insurance"}`) }}
                            </div>
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"contactStart"}`) }}
                            </div>
                            <div class="table__label table__label--medium">{{ $t(`policies.${"tableHead"}.${"contactEnd"}`) }}</div>
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"dueDate"}`) }}
                            </div>
                            <div class="table__label table__label--medium"> 
                                {{ $t(`policies.${"tableHead"}.${"caseWorker"}`) }}
                            </div>
                            <div class="table__label table__label--medium">{{ $t(`policies.${"tableHead"}.${"netPremium"}`) }}</div>
                            <div class="table__label table__label--medium">{{ $t(`policies.${"tableHead"}.${"grossPremium"}`) }}</div>
                            <div class="table__label table__label--medium">{{ $t(`policies.${"tableHead"}.${"payment"}`) }}</div>
                            <div class="table__label table__label--medium services__label--delete"></div>
                            <div class="table__label table__label--medium services__label--delete"></div>
                        </div>
                        <PolicyService v-for="(service, index) in services" :key="service.id" :service="service"
                            :mandate="policy.mandate" :fetchGlobalCustomer="fetchGlobalCustomer"
                            :isLastService="index === services.length - 1" :totalNetto="policy.total_netto"
                            :totalBrutto="policy.total_bruto" :owner="policy.owner" :createdAt="policy.created_at" />
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import statics from "@/statics";
import PolicyService from "@/components/AccountDetails/PolicyService";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
import { formatDisplayDate } from "@/helpers/dateFormatters";
import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";

defineOptions({
    name: "Policy"
});

const props = defineProps({
    policy: {
        required: true,
        type: Object,
    },
    expandedPolicyId: {
        type: Number,
        required: false,
    }
});

const store = useStore();
const route = useRoute();

// State
const showMoreDetails = ref(false);
const showStatusPopup = ref(false);
const showAgentPopup = ref(false);
const showPolicyNumberPopup = ref(false);
const showPolicyPlateNrPopup = ref(false);
const showSubmitDatePopup = ref(false);
const policyLoading = ref(false);
const statusesArr = ref(null);
const servicesRef = ref(null);
const servicesHeight = ref(0);

// Lifecycle
onMounted(() => {
    if (props.policy.id == props.expandedPolicyId) {
        showMoreDetails.value = true;
    }
});

// Computed
const policyForms = computed(() => store.getters.policyForms);

const policyStatus = computed(() =>
    (props.policy?.policy_status?.name) ? props.policy.policy_status.name : statics.empty
);

const policyNumber = computed(() => props.policy.policy_number || statics.empty);
const plateNumber = computed(() => props.policy.plate_number || null);

const createdAt = computed(() =>
    props.policy.created_at ? formatDisplayDate(props.policy.created_at) : statics.empty
);

const submitDate = computed(() =>
    props.policy.submit_date ? formatDisplayDate(props.policy.submit_date) : statics.empty
);

const agent = computed(() =>
    props.policy.agent
        ? `${props.policy.agent.first_name || statics.empty} ${props.policy.agent.last_name || statics.empty}`
        : statics.empty
);

const agent2 = computed(() =>
    props.policy.second_agent
        ? `${props.policy.second_agent.first_name || statics.empty} ${props.policy.second_agent.last_name || statics.empty}`
        : statics.empty
);

const company = computed(() =>
    props.policy.company ? (props.policy.company.name || props.policy.company.full_name || statics.empty) : statics.empty
);

const branch = computed(() => {
    if (props.policy.policy_services.length) {
        return props.policy.policy_services[0].service.branch_category.name || statics.empty;
    }
    return null;
});

const services = computed(() =>
    props.policy.policy_services.length ? props.policy.policy_services : []
);

//const policyMandateService = computed(() => props.policy.mandate ? props.policy.mandate.service.code : null);

const policyStatusColor = computed(() => {
    if (props.policy.policy_status) {
        const status = statics.policyStatuses.find(s => props.policy.policy_status.id === s.id);
        return status ? status.name : null;
    }
    return null;
});

const policyStatuses = computed(() => statusesArr.value);
const agents = computed(() => policyForms.value.agents);

watch(
    [showMoreDetails, services],
    async () => {
        if (!showMoreDetails.value) {
            servicesHeight.value = 0;
            return;
        }

        await nextTick();
        servicesHeight.value = servicesRef.value?.scrollHeight || 0;
    },
    { immediate: true, deep: true }
);

// Methods
const handleStatusPopup = (teamId) => {
    getPolicyFormData(teamId);
    showStatusPopup.value = true;
};

const getPolicyFormData = async (id) => {
    await store.dispatch("getPolicyForms", id);
    statusesArr.value = policyForms.value["policy-statuses"];
};

const updatePolicyStatus = async (policyStatusId) => {
    policyLoading.value = true;
    await store.dispatch("updatePolicyStatus", {
        policyId: props.policy.id,
        policyStatusId,
    });
    await fetchGlobalCustomer(route.params.id);
    showStatusPopup.value = false;
    policyLoading.value = false;
};

const updatePolicyAgent = async (policyAgentId) => {
    policyLoading.value = true;
    await store.dispatch("updatePolicyAgent", {
        policyId: props.policy.id,
        policyAgentId,
    });
    await fetchGlobalCustomer(route.params.id);
    showAgentPopup.value = false;
    policyLoading.value = false;
};

const updatePolicyNumber = async (policyNumber) => {
    policyLoading.value = true;
    await store.dispatch("updatePolicyNumber", {
        policyId: props.policy.id,
        policyNumber,
    });
    await fetchGlobalCustomer(route.params.id);
    showPolicyNumberPopup.value = false;
    policyLoading.value = false;
};

const updatePlateNumber = async (plateNumber) => {
    policyLoading.value = true;
    await store.dispatch("updatePlateNumber", {
        policyId: props.policy.id,
        plateNumber,
    });
    await fetchGlobalCustomer(route.params.id);
    showPolicyPlateNrPopup.value = false;
    policyLoading.value = false;
};

const updateSubmitDate = async (submitDate) => {
    policyLoading.value = true;
    await store.dispatch("updateSubmitDate", {
        policyId: props.policy.id,
        submitDate,
    });
    await fetchGlobalCustomer(route.params.id);
    showSubmitDatePopup.value = false;
    policyLoading.value = false;
};

const openPolicyFilesModal = () => {
    store.commit("setPolicyFileId", props.policy.id);
    store.commit("setPolicyFiles", props.policy.policy_files);
    store.commit("setPolicyFilesModalIsTermination", false);
    store.commit("setShowPolicyFilesModal", true);
};
</script>

<style lang="scss" scoped>
.table {
    &__header {
        padding-left: 15px;
    }

    &__label {
        padding: 0;
        text-align: left;
    }
}

.agent-field {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    gap: 5px !important;
}
</style>
